import { Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DeliberaService } from '../../services/delibera.service';
import { Delibera, TipoDelibera } from '../../model/delibere-data';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../environment/environment';
import { DomandeService } from '../../services/domande.service';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { IscrittoItem, RicercaIscritto } from '../../model/cnop-data';
import { IscrittiService } from '../../services/iscritti.service';
import { StpService } from '../../services/stp.service';

@Component({
  selector: 'app-dialog-delibera-iscritto',
  templateUrl: './dialog-delibera-iscritto.component.html',
  styleUrl: './dialog-delibera-iscritto.component.scss'
})
export class DialogDeliberaIscrittoComponent implements OnInit{

  //services
  private iscritti_service = inject(IscrittiService);
  private dialog_config = inject(DynamicDialogConfig);
  private dialog_ref = inject(DynamicDialogRef);

  stpId = 0;

  //spinner dei bottoni
  isLoadingSpinner = false;

  //dati inserimento professionista
  lista: IscrittoItem[] = [];

  //form filtro professinista
  professionistiFiltered: IscrittoItem[] = [];

  professionistiSearch = new FormGroup({
    professionistaSelezionato: new FormControl<IscrittoItem|null>(null)
  })

  ngOnInit(): void {
    this.stpId = this.dialog_config.data.stpId;
    this.gestioneListaSelezionabili('');
  }

  inputValueAutocomplete(event: any){
    const val = event.target.value;
    this.gestioneListaSelezionabili(val);
  }

  gestioneListaSelezionabili(par: string){

    const parametro: RicercaIscritto = {
      criterio: par
    };

    this.iscritti_service.getIscrittiCnop(parametro).subscribe((result: IscrittoItem[]) => {
      this.lista = result;
      this.lista = this.lista.map(pro => ({
        ...pro,
        anagrafica: `${pro.nome}, ${pro.cognome}, ${pro.codiceFiscale}`
      }));
    });

  }

  //gestione del filtraggio dei professionisti
  filterProfessionisti(event: AutoCompleteCompleteEvent){
    const query = event.query.toLowerCase();
    const queryParts = query.split(" ");

    this.professionistiFiltered = this.lista.filter(professionista =>
      queryParts.every(part =>
        `${professionista.nome} ${professionista.cognome} ${professionista.codiceFiscale}`.toLowerCase().includes(part)
      )
    )
  }

  //invio del nuovo professionista
  iscrizioneProfessionista(){
    const pro = this.professionistiSearch.get('professionistaSelezionato')?.value;
    this.isLoadingSpinner = true;

    setTimeout(() => {
      this.isLoadingSpinner = false;
      this.dialog_ref.close({
        pro
      })
    }, 1500);
  }

}
